<template>
  <div>
    <v-data-table
        :headers="headers"
        :items="activities"
        sort-by="category"
        class="elevation-1"
        :loading="$apollo.queries.activities.loading"
        loading-text="Lütfen bekleyiniz"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>AKTİVİTELER</v-toolbar-title>
          <v-divider
              class="mx-4"
              inset
              vertical
          ></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
              >Ekle</v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedItem.name" label="Ad"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedItem.category" label="Kategori"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedItem.eventSummary" label="Açıklama"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-switch v-model="editedItem.timed" label="Gün içinde"></v-switch>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-datetime-picker :time-picker-props="{disabled: !editedItem.timed}" clear-text="Temizle" ok-text="Tamam" v-model="editedItem.start" label="Başlangıç">
                        <template v-slot:dateIcon><v-icon>mdi-calendar</v-icon></template>
                        <template v-slot:timeIcon><v-icon>mdi-clock</v-icon></template>
                      </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-datetime-picker :time-picker-props="{disabled: !editedItem.timed}" clear-text="Temizle" ok-text="Tamam" v-model="editedItem.end" label="Bitiş">
                        <template v-slot:dateIcon><v-icon>mdi-calendar</v-icon></template>
                        <template v-slot:timeIcon><v-icon>mdi-clock</v-icon></template>
                      </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-autocomplete v-model="editedItem.classroom.id" :items="classrooms" item-text="name" item-value="id" label="Sınıflar"></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">İptal</v-btn>
                <v-btn color="blue darken-1" text @click="save">Kaydet</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.timed="{ item }">
        <v-simple-checkbox
            v-model="item.timed"
            disabled
        ></v-simple-checkbox>
      </template>
      <template v-slot:item.start="{ item }">{{ time(item.start) }}</template>
      <template v-slot:item.end="{ item }">{{ time(item.end) }}</template>
      <template v-slot:item.actions="{ item }">
        <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
            small
            @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:no-data>
        <p>Aktivite bulunamadı</p>
      </template>
    </v-data-table>
    <my-snackbar ref="snackbar"/>
  </div>

</template>

<script>
import {ACTIVITIES, CLASSROOMS} from '@/graphql/queries'
import {CreateActivity, DeleteActivity, UpdateActivity} from '@/graphql/mutations/activity'
import MySnackbar from "@/components/mySnackbar";


export default {
  components: {MySnackbar},

  data: () => ({
    dialog: false,
    headers: [
      {
        text: 'Ad',
        align: 'start',
        sortable: false,
        value: 'name',
      },
      { text: 'Kategori', value: 'category' },
      { text: 'Açıklama', value: 'eventSummary' },
      { text: 'Gün Boyu', value: 'timed' },
      { text: 'Başlangıç', value: 'start' },
      { text: 'Bitiş', value: 'end' },
      { text: 'Sınıf', value: 'classroom.name' },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
    editedIndex: -1,
    editedItem: {
      id: null,
      name: '',
      category: '',
      eventSummary: '',
      start: '',
      end: '',
      timed: false,
      classroom: {
        id: null,
        name: ''
      }
    },
    defaultItem: {
      id: null,
      name: '',
      category: '',
      eventSummary: '',
      start: '',
      end: '',
      timed: false,
      classroom: {
        id: null,
        name: ''
      }
    },
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Ekle' : 'Düzenle'
    },
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
  },

  apollo: {
    activities: {
      query: ACTIVITIES,
      variables () {
        return {
          classroomId: this.editedItem.classroom.id,
        }
      },
      error(error) {
       this.$refs.snackbar.raiseError(error.message)
      },
    },
    classrooms: {
      query: CLASSROOMS,
    },
  },

  methods: {
    time(date){
      return new Date(date).toLocaleString()
    },
    editItem (item) {
      this.editedIndex = this.activities.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedItem.start = new Date(this.editedItem.start)
      this.editedItem.end = new Date(this.editedItem.end)
      this.dialog = true
    },

    async deleteItem (item) {
      const index = this.activities.indexOf(item)
      confirm('Silmek istediğinize emin misiniz?') && await this.deleteActivity(index, item)
    },

    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    async save () {
      if (this.editedIndex > -1) {
        await this.updateActivity()
      } else {
        // add activity
        await this.addActivity()

      }
      this.close()
    },

    async addActivity () {
      await this.$apollo.mutate({
        mutation: CreateActivity,
        variables: {
          name: this.editedItem.name,
          category: this.editedItem.category,
          eventSummary: this.editedItem.eventSummary,
          start: this.editedItem.start,
          end: this.editedItem.end,
          timed: this.editedItem.timed,
          classroomId: this.editedItem.classroom.id
        },

        update: (store, { data: { createActivity } }) => {
          // Read the data from our cache for this query.
          const data = store.readQuery({ query: ACTIVITIES, variables: {classroomId: this.editedItem.classroom.id} })
          // Add our tag from the mutation to the end
          data.activities.push(createActivity.activity)
          // Write our data back to the cache.
          store.writeQuery({ query: ACTIVITIES, variables: {classroomId: this.editedItem.classroom.id}, data })

        },
      }).catch((error) => {
        // Error
       this.$refs.snackbar.raiseError(error.message)
      })
    },

    async updateActivity () {
      await this.$apollo.mutate({
        mutation: UpdateActivity,
        variables: {
          name: this.editedItem.name,
          category: this.editedItem.category,
          eventSummary: this.editedItem.eventSummary,
          start: this.editedItem.start,
          end: this.editedItem.end,
          timed: this.editedItem.timed,
          id: this.editedItem.id
        },
        update: (store, { data: { updateActivity } }) => {

          // Read the data from our cache for this query.
          const data = store.readQuery({ query: ACTIVITIES, variables: {classroomId: this.editedItem.classroom.id} })
          // Add our tag from the mutation to the end
          data.activities[this.editedIndex] = updateActivity.activity
          // Write our data back to the cache.
          store.writeQuery({ query: ACTIVITIES, variables: {classroomId: this.editedItem.classroom.id}, data })


        },
      }).catch((error) => {
        // Error
       this.$refs.snackbar.raiseError(error.message)
      })
    },

    async deleteActivity (index, item) {
      await this.$apollo.mutate({
        mutation: DeleteActivity,
        variables: {
          id: item.id
        },
        update: (store,) => {
          // Read the data from our cache for this query.
          const data = store.readQuery({ query: ACTIVITIES, variables: {classroomId: this.editedItem.classroom.id} })
          // Add our tag from the mutation to the end
          data.activities.splice(index, 1)
          // Write our data back to the cache.
          store.writeQuery({ query: ACTIVITIES, variables: {classroomId: this.editedItem.classroom.id}, data })

        },
      }).catch((error) => {
        // Error
       this.$refs.snackbar.raiseError(error.message)
      })
    }


  },
}
</script>


<style scoped>

</style>
